import React from 'react'

function Footer() {
  return (
    <>
  <script src="backend/assets/libs/jquery/dist/jquery.min.js"></script>
  <script src="backend/assets/libs/bootstrap/dist/js/bootstrap.bundle.min.js"></script>
  <script src="backend/assets/js/sidebarmenu.js"></script>
  <script src="backend/assets/js/app.min.js"></script>
  <script src="backend/assets/libs/apexcharts/dist/apexcharts.min.js"></script>
  <script src="backend/assets/libs/simplebar/dist/simplebar.js"></script>
  <script src="backend/assets/js/dashboard.js"></script>
  </>
  )
}

export default Footer